export default "__VITE_ASSET__DGu3Do5g__"